import React, { useState, useEffect, useRef } from "react";
import { PopupMenu, PopupMenuItem } from "@hopper/popup_menu";
import { Link } from "react-router-dom";

import logo from "assets/images/logo.svg";
import { testerAccountPaths } from "configuration/app_paths";
import Footer from "components/layout/shared/footer";
import Dropdown from "components/shared/dropdown";
import style from "./style.module.scss";

const DropdownMenuTrigger = () => (
  <div className="flex m-md">
    <span className="text-primary mr-xs glyphicon glyphicon-user" aria-hidden="true" />
    <div className={`${style["caret"]} text-primary`} />
  </div>
);

const SplashPopupMenu = () => (
  <div>
    <PopupMenu>
      <Link to={testerAccountPaths.signOut}>
        <PopupMenuItem>
          <span className="text-darkest">
            <i className="fa fa-sign-out" /> Logout
          </span>
        </PopupMenuItem>
      </Link>
    </PopupMenu>
  </div>
);

type SplashLayoutProps = {
  children: React.ReactNode;
};

const SplashLayout = ({ children }: SplashLayoutProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigationMenuRef = useRef<HTMLDivElement>(null);

  const toggleShowMenu = () => setShowMenu(!showMenu);

  const hidePopupMenu = (event: Event) => {
    if (navigationMenuRef.current && !navigationMenuRef.current.contains(event.target as Element)) {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", hidePopupMenu);

    return () => {
      document.removeEventListener("click", hidePopupMenu);
    };
  });

  return (
    <div className="relative min-h-screen container-fluid">
      <div className="row">
        <div className="col-lg-12" style={{ boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.12)" }}>
          <nav className="flex justify-between content-center px-3xl py-lg">
            <div className="flex justify-center flex-col">
              <img src={logo} style={{ height: 20 }} alt="Tester Work logo" />
            </div>
            <div
              className="hover:bg-light nav navbar-top-links cursor-pointer"
              ref={navigationMenuRef}
              data-test-role="navigation"
            >
              <Dropdown dropdownElement={SplashPopupMenu} isOpen={showMenu} offset={16}>
                <span onClick={toggleShowMenu}>
                  <DropdownMenuTrigger />
                </span>
              </Dropdown>
            </div>
          </nav>
        </div>
      </div>
      <div className="wrapper wrapper-content pt-0">
        <div className="container">
          <div>{children}</div>
        </div>

        <div className="absolute left-0 bottom-0 right-0 pl-md py-sm">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default SplashLayout;
